import React from 'react';
import { AppRoute, AppSwitch, baseAppRouteMap } from 'src/app-routes';
import { Analytics } from 'src/components-bl/Analytics/Analytics';

interface IDataInsightsContainer {
  shopId: number;
}

export const AnalyticsContainer = ({ shopId }: IDataInsightsContainer): JSX.Element => {
  return (
    <AppSwitch>
      <AppRoute
        route={baseAppRouteMap.analytics}
        Component={Analytics}
        componentProps={{ shopId }}
        exact
      />
    </AppSwitch>
  );
};
